<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <router-view></router-view>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
        }
    }

}
</script>
